import React from 'react';
import { Alert } from 'react-bootstrap';

const ErrorAlert = ({ error }) => {
  if (!error) return null;

  const displayError =
    typeof error === 'string' ? error : JSON.stringify(error, null, 2);

  return (
    <Alert variant="danger" className="mb-4">
      <Alert.Heading>
        <i className="fas fa-exclamation-triangle me-2"></i>Error
      </Alert.Heading>
      <pre style={{ margin: 0 }}>{displayError}</pre>
    </Alert>
  );
};

export default ErrorAlert;
